import { useQueryMe } from '@ben/shared/hooks/queries/use-query-me';
import { useParams } from 'react-router-dom';

/** Allows components to render in EA or ECC and use the appropriate employeeId */
export const useEmployeeId = () => {
  const { employeeId } = useParams();
  const { data: employee } = useQueryMe({ enabled: !employeeId });
  return Number(employeeId ?? employee?.id);
};
